import { memo, useEffect, useRef } from "react";
import Stats from "stats.js";

import { useFeatureFlags } from "../liveblocks/maps";

export function useFpsMeter() {
  const [featureFlags] = useFeatureFlags();
  const statsRef = useRef<Stats | undefined>();
  const memoryRef = useRef<HTMLElement | null>();
  const animationFrameIdRef = useRef<number | undefined>();

  useEffect(() => {
    function initStats() {
      const stats = new Stats();
      /** Override default CSS (https://github.com/mrdoob/stats.js/blob/4a46c8b7e89e8a210ffc0e71450b12369d9f49e3/src/Stats.js#L10) */
      stats.dom.style.cssText =
        "position:fixed;top:0;right:0;cursor:pointer;opacity:0.9;z-index:10000";
      document.body.appendChild(stats.dom);
      statsRef.current = stats;

      memoryRef.current = document.createElement("div");
      memoryRef.current.style.cssText =
        "position:fixed;top:48px;right:0;cursor:pointer;opacity:0.9;z-index:10000;color: white;background: black;font-size: 12px;padding: 2px;";
      document.body.appendChild(memoryRef.current);

      animationFrameIdRef.current = requestAnimationFrame(updateStats);
    }

    function updateStats() {
      statsRef.current?.update();
      // @ts-ignore
      if (memoryRef.current && window.performance.memory) {
        memoryRef.current.innerHTML = `${
          // @ts-ignore
          Math.round(window.performance.memory.usedJSHeapSize / 1024 / 1024)
        } MB used`;
      }
      animationFrameIdRef.current = requestAnimationFrame(updateStats);
    }

    function destroyStats() {
      animationFrameIdRef.current &&
        cancelAnimationFrame(animationFrameIdRef.current);
      animationFrameIdRef.current = undefined;
      statsRef.current && statsRef.current.dom.remove();
      statsRef.current = undefined;
      if (memoryRef.current) {
        document.body.removeChild(memoryRef.current);
        memoryRef.current = null;
      }
    }

    if (featureFlags?.shouldShowFpsMeter && !statsRef.current) {
      initStats();
      return () => destroyStats();
    } else if (!featureFlags?.shouldShowFpsMeter && statsRef.current) {
      destroyStats();
    }
  }, [featureFlags?.shouldShowFpsMeter]);
}
